import { __decorate } from 'tslib';
import { ɵɵdefineInjectable, Injectable, EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NgxFlowchartComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 5);
    ɵngcc0.ɵɵelementStart(2, "g", 6);
    ɵngcc0.ɵɵelementStart(3, "g", 7);
    ɵngcc0.ɵɵelement(4, "rect", 8);
    ɵngcc0.ɵɵelement(5, "path", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c0 = function (a0, a1, a2, a3, a4) { return { "background": a0, "color": a1, "border-radius": a2, "box-shadow": a3, "min-width": a4 }; };
function NgxFlowchartComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "span", 11);
    ɵngcc0.ɵɵlistener("click", function NgxFlowchartComponent_ng_container_1_div_2_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const item_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clickFlow(item_r1); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction5(2, _c0, ctx_r4.options.background, ctx_r4.options.textColor, ctx_r4.options.borderRadius, ctx_r4.options.shadow, ctx_r4.options.width));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r1.name);
} }
function NgxFlowchartComponent_ng_container_1_div_3_ng_container_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 14);
    ɵngcc0.ɵɵelementStart(2, "g", 6);
    ɵngcc0.ɵɵelementStart(3, "g", 7);
    ɵngcc0.ɵɵelement(4, "rect", 8);
    ɵngcc0.ɵɵelement(5, "path", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function NgxFlowchartComponent_ng_container_1_div_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "span", 11);
    ɵngcc0.ɵɵlistener("click", function NgxFlowchartComponent_ng_container_1_div_3_ng_container_3_Template_span_click_2_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r15); const d_r11 = restoredCtx.$implicit; const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.clickFlow(d_r11); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, NgxFlowchartComponent_ng_container_1_div_3_ng_container_3_ng_container_4_Template, 6, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const d_r11 = ctx.$implicit;
    const j_r12 = ctx.index;
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction5(3, _c0, ctx_r10.options.background, ctx_r10.options.textColor, ctx_r10.options.borderRadius, ctx_r10.options.shadow, ctx_r10.options.width));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(d_r11.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", j_r12 !== item_r1.groupData.length - 1);
} }
const _c1 = function (a0, a1, a2, a3) { return { "background": a0, "color": a1, "border-radius": a2, "box-shadow": a3 }; };
function NgxFlowchartComponent_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵlistener("click", function NgxFlowchartComponent_ng_container_1_div_3_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r19); const item_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.clickFlow(item_r1); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, NgxFlowchartComponent_ng_container_1_div_3_ng_container_3_Template, 5, 9, "ng-container", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction4(3, _c1, ctx_r5.options.groupBackground, ctx_r5.options.groupTextColor, ctx_r5.options.groupBorderRadius, ctx_r5.options.groupShadow));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r1.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r1.groupData);
} }
function NgxFlowchartComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NgxFlowchartComponent_ng_container_1_ng_container_1_Template, 6, 0, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, NgxFlowchartComponent_ng_container_1_div_2_Template, 3, 8, "div", 3);
    ɵngcc0.ɵɵtemplate(3, NgxFlowchartComponent_ng_container_1_div_3_Template, 4, 8, "div", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r2 !== 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.groupData == undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.groupData !== undefined);
} }
let NgxFlowchartService = class NgxFlowchartService {
    constructor() { }
};
NgxFlowchartService.ɵfac = function NgxFlowchartService_Factory(t) { return new (t || NgxFlowchartService)(); };
NgxFlowchartService.ɵprov = ɵɵdefineInjectable({ factory: function NgxFlowchartService_Factory() { return new NgxFlowchartService(); }, token: NgxFlowchartService, providedIn: "root" });

let NgxFlowchartComponent = class NgxFlowchartComponent {
    constructor() {
        /**
         * Click Event
         */
        this.clickName = new EventEmitter();
        /**
         * option
         */
        this.options = {
            groupBackground: 'linear-gradient(to bottom,#b9b9b9 0,#fefefe 100%)',
            groupShadow: '0 0.3rem 0.5rem 0 rgba(44,51,73,.5)',
            groupBorderRadius: '3px',
            groupTextColor: '#000',
            background: '#0e3e7d',
            shadow: '0 2px 4px 0 #333',
            borderRadius: '5px',
            textColor: '#fff',
            width: '200px'
        };
    }
    ngOnInit() {
    }
    clickFlow(data) {
        this.clickName.emit(data);
    }
};
NgxFlowchartComponent.ɵfac = function NgxFlowchartComponent_Factory(t) { return new (t || NgxFlowchartComponent)(); };
NgxFlowchartComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxFlowchartComponent, selectors: [["ngx-flowchart"]], inputs: { options: "options", data: "data" }, outputs: { clickName: "clickName" }, decls: 2, vars: 1, consts: [[1, "flow-total"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["class", "flow-operation", 4, "ngIf"], ["class", "flow-group", 3, "ngStyle", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", "width", "100%", "height", "100%", "viewBox", "0 0 24 24", "fill", "#222b45", 2, "margin", ".1rem 0 .2rem 0", "width", "24px", "height", "24px"], ["data-name", "Layer 2"], ["data-name", "arrow-downward"], ["width", "24", "height", "24", "opacity", "0"], ["d", "M18.77 13.36a1 1 0 0 0-1.41-.13L13 16.86V5a1 1 0 0 0-2 0v11.86l-4.36-3.63a1 1 0 1 0-1.28 1.54l6 5 .15.09.13.07a1 1 0 0 0 .72 0l.13-.07.15-.09 6-5a1 1 0 0 0 .13-1.41z"], [1, "flow-operation"], [3, "ngStyle", "click"], [1, "flow-group", 3, "ngStyle"], [2, "font-size", "1.2rem", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "width", "100%", "height", "100%", "viewBox", "0 0 24 24", "fill", "#222b45", 2, "margin", ".3rem 0 0 0", "width", "24px", "height", "24px"]], template: function NgxFlowchartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NgxFlowchartComponent_ng_container_1_Template, 4, 3, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.data);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgStyle], styles: [".flow-total[_ngcontent-%COMP%]{text-align:center;display:flex;flex-direction:column;align-items:center}.flow-group[_ngcontent-%COMP%]{padding:.6rem 2rem .5rem;background:linear-gradient(to bottom,#b9b9b9 0,#fefefe 100%);color:#000;margin-bottom:.3rem;border-radius:3px;box-shadow:0 .3rem .5rem 0 rgba(44,51,73,.5);min-width:200px}.flow-operation[_ngcontent-%COMP%]{display:flex;margin:.3rem 0;align-items:center;justify-content:center;font-size:.89rem;flex-direction:column}.flow-operation[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background:#0e3e7d;color:#fff;padding:.5rem 2rem;border-radius:5px;box-shadow:0 2px 4px 0 #333}.flow-operation[_ngcontent-%COMP%]   nb-icon[_ngcontent-%COMP%]{margin-top:.3rem;width:1.5em;height:1.5em}.flow-total[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{cursor:pointer;min-width:200px}"] });
__decorate([
    Input()
], NgxFlowchartComponent.prototype, "data", void 0);
__decorate([
    Output()
], NgxFlowchartComponent.prototype, "clickName", void 0);
__decorate([
    Input()
], NgxFlowchartComponent.prototype, "options", void 0);

let NgxFlowchartModule = class NgxFlowchartModule {
};
NgxFlowchartModule.ɵfac = function NgxFlowchartModule_Factory(t) { return new (t || NgxFlowchartModule)(); };
NgxFlowchartModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxFlowchartModule });
NgxFlowchartModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFlowchartService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFlowchartComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-flowchart',
                template: "<div class=\"flow-total\">\r\n    <ng-container *ngFor=\"let item of data; let i = index\">\r\n        <ng-container *ngIf=\"i !== 0\">\r\n            <svg style=\"margin: .1rem 0 .2rem 0; width: 24px; height: 24px;\" xmlns=\"http://www.w3.org/2000/svg\"\r\n                width=\"100%\" height=\"100%\" viewBox=\"0 0 24 24\" fill=\"#222b45\">\r\n                <g data-name=\"Layer 2\">\r\n                    <g data-name=\"arrow-downward\">\r\n                        <rect width=\"24\" height=\"24\" opacity=\"0\"></rect>\r\n                        <path\r\n                            d=\"M18.77 13.36a1 1 0 0 0-1.41-.13L13 16.86V5a1 1 0 0 0-2 0v11.86l-4.36-3.63a1 1 0 1 0-1.28 1.54l6 5 .15.09.13.07a1 1 0 0 0 .72 0l.13-.07.15-.09 6-5a1 1 0 0 0 .13-1.41z\">\r\n                        </path>\r\n                    </g>\r\n                </g>\r\n            </svg>\r\n        </ng-container>\r\n        <div *ngIf=\"item.groupData == undefined\" class=\"flow-operation\">\r\n            <span (click)=\"clickFlow(item)\"\r\n                [ngStyle]=\"{'background': options.background, 'color': options.textColor, \r\n            'border-radius': options.borderRadius,'box-shadow': options.shadow, 'min-width': options.width}\">{{item.name}}</span>\r\n        </div>\r\n        <div *ngIf=\"item.groupData !== undefined\" class=\"flow-group\" [ngStyle]=\"{'background': options.groupBackground, 'color': options.groupTextColor, \r\n                    'border-radius': options.groupBorderRadius,'box-shadow': options.groupShadow}\">\r\n            <span (click)=\"clickFlow(item)\" style='font-size: 1.2rem'>{{item.name}}</span>\r\n            <ng-container *ngFor=\"let d of item.groupData; let j = index\">\r\n                <div class=\"flow-operation\">\r\n                    <span (click)=\"clickFlow(d)\"\r\n                        [ngStyle]=\"{'background': options.background, 'color': options.textColor, \r\n                    'border-radius': options.borderRadius,'box-shadow': options.shadow, 'min-width': options.width}\">{{d.name}}</span>\r\n                    <ng-container *ngIf=\"j !== (item.groupData.length - 1)\">\r\n                        <svg style=\"margin: .3rem 0 0 0; width: 24px; height: 24px\" xmlns=\"http://www.w3.org/2000/svg\"\r\n                            width=\"100%\" height=\"100%\" viewBox=\"0 0 24 24\" fill=\"#222b45\">\r\n                            <g data-name=\"Layer 2\">\r\n                                <g data-name=\"arrow-downward\">\r\n                                    <rect width=\"24\" height=\"24\" opacity=\"0\"></rect>\r\n                                    <path\r\n                                        d=\"M18.77 13.36a1 1 0 0 0-1.41-.13L13 16.86V5a1 1 0 0 0-2 0v11.86l-4.36-3.63a1 1 0 1 0-1.28 1.54l6 5 .15.09.13.07a1 1 0 0 0 .72 0l.13-.07.15-.09 6-5a1 1 0 0 0 .13-1.41z\">\r\n                                    </path>\r\n                                </g>\r\n                            </g>\r\n                        </svg>\r\n                    </ng-container>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n    </ng-container>\r\n</div>",
                styles: [".flow-total{text-align:center;display:flex;flex-direction:column;align-items:center}.flow-group{padding:.6rem 2rem .5rem;background:linear-gradient(to bottom,#b9b9b9 0,#fefefe 100%);color:#000;margin-bottom:.3rem;border-radius:3px;box-shadow:0 .3rem .5rem 0 rgba(44,51,73,.5);min-width:200px}.flow-operation{display:flex;margin:.3rem 0;align-items:center;justify-content:center;font-size:.89rem;flex-direction:column}.flow-operation span{background:#0e3e7d;color:#fff;padding:.5rem 2rem;border-radius:5px;box-shadow:0 2px 4px 0 #333}.flow-operation nb-icon{margin-top:.3rem;width:1.5em;height:1.5em}.flow-total span{cursor:pointer;min-width:200px}"]
            }]
    }], function () { return []; }, { clickName: [{
            type: Output
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFlowchartModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxFlowchartComponent],
                imports: [
                    CommonModule
                ],
                exports: [NgxFlowchartComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxFlowchartModule, { declarations: function () { return [NgxFlowchartComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxFlowchartComponent]; } }); })();

/*
 * Public API Surface of ngx-flowchart
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxFlowchartComponent, NgxFlowchartModule, NgxFlowchartService };

